import ReportingDashboardApiTab from '@/Enums/ReportingDashboard/ApiTab.enum';
import { ApiTabIndex } from '@/Enums/ReportingDashboard/ApiTabIndex.enum';
import PrintTabOption from '@/Enums/ReportingDashboard/PrintTabOption.enum';

export const NO_ROWS_LABEL = 'Please Refresh Page';

export const ApiTabsToQueryParams: Record<ApiTabIndex, PrintTabOption> = {
  [ApiTabIndex.Omnichannel]: PrintTabOption.Omnichannel,
  [ApiTabIndex.Google]: PrintTabOption.Google,
  [ApiTabIndex.Adswizz]: PrintTabOption.Adswizz,
  [ApiTabIndex.Dooh]: PrintTabOption.Dooh,
  [ApiTabIndex.Search]: PrintTabOption.Search,
  [ApiTabIndex.Social]: PrintTabOption.Social,
  [ApiTabIndex.Simplifi]: PrintTabOption.Simplifi,
  [ApiTabIndex.Gam]: PrintTabOption.Gam,
};

export const PrintOptionLabel: Record<PrintTabOption, ReportingDashboardApiTab> = {
  [PrintTabOption.Omnichannel]: ReportingDashboardApiTab.Omnichannel,
  [PrintTabOption.Google]: ReportingDashboardApiTab.Google,
  [PrintTabOption.Adswizz]: ReportingDashboardApiTab.Adswizz,
  [PrintTabOption.Dooh]: ReportingDashboardApiTab.Dooh,
  [PrintTabOption.Search]: ReportingDashboardApiTab.Search,
  [PrintTabOption.Social]: ReportingDashboardApiTab.Social,
  [PrintTabOption.Simplifi]: ReportingDashboardApiTab.Simplifi,
  [PrintTabOption.Gam]: ReportingDashboardApiTab.Gam,
};

export const REPORTING_TAB_LABELS: Record<ReportingDashboardApiTab, string> = {
  [ReportingDashboardApiTab.Omnichannel]: ReportingDashboardApiTab.Omnichannel,
  [ReportingDashboardApiTab.Google]: ReportingDashboardApiTab.Google,
  [ReportingDashboardApiTab.Adswizz]: ReportingDashboardApiTab.Adswizz,
  [ReportingDashboardApiTab.Dooh]: ReportingDashboardApiTab.Dooh,
  [ReportingDashboardApiTab.Search]: ReportingDashboardApiTab.Search,
  [ReportingDashboardApiTab.Social]: ReportingDashboardApiTab.Social,
  [ReportingDashboardApiTab.Simplifi]: 'Place-Based & Keyword',
  [ReportingDashboardApiTab.Gam]: ReportingDashboardApiTab.Gam,
};
